import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

/**
 * Слайдер Оборудования (синий блок).
 * Зацикленность слайдера включается только в слайдере больше 1 слайда.
 * @constructor
 */
export default function OurEquipmentSlider() {
  const options = {
    direction: 'horizontal',
    spaceBetween: 20,
    slidesPerView: 1,
    slidesPerColumn: 1,
    preloadImages: false,
    draggable: true,
    rewind: true,
    pagination: {
      el: '.equipment-slider .swiper-pagination',
      clickable: true,
      renderBullet: (index, className) => `<div class="pagination-dot ${className}"></div>`,
    },
    autoplay: {
      enabled: true,
      delay: 6000,
      disableOnInteraction: false,
    },
  };

  // eslint-disable-next-line no-new
  new Swiper('.equipment-slider .swiper', options);
}
